var _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTips({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_x32_",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "800px",
    height: "800px",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    fill: "#0e5aa7",
    stroke: "#0e5aa7",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "  .st0{fill:#0e5aa7;}  "), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M360.266,43.188C333.656,16.531,296.656-0.016,256,0c-40.656-0.016-77.656,16.531-104.266,43.188 c-26.641,26.625-43.203,63.609-43.188,104.266c-0.016,34.641,12.016,66.656,32.078,91.797c5.906,7.438,11.016,13.609,15.094,18.906 c3.063,3.969,5.547,7.438,7.516,10.594c2.953,4.75,4.75,8.672,6.078,13.375c1.297,4.719,2.094,10.469,2.109,18.594 c0,5.469,0.609,10.797,2.141,16.031c1.141,3.906,2.844,7.781,5.25,11.344c3.547,5.375,8.813,9.891,14.594,12.563 c5.766,2.703,11.781,3.688,17.391,3.688h90.422c4.984,0,10.281-0.781,15.469-2.859c3.875-1.547,7.656-3.859,10.875-6.828 c4.875-4.438,8.297-10.141,10.281-15.953c2-5.844,2.75-11.828,2.75-17.984c0-7.219,0.641-12.578,1.688-16.969 c1.625-6.563,4-11.438,8.641-18.266c4.609-6.766,11.578-15.078,20.484-26.234c20.047-25.141,32.063-57.172,32.047-91.797 C403.469,106.797,386.906,69.813,360.266,43.188z M338.531,213.063c-5.672,7.094-10.781,13.297-15.516,19.406 c-3.531,4.594-6.859,9.156-9.906,14.031c-4.547,7.281-8.422,15.375-10.922,24.438s-3.625,18.859-3.625,29.781 c0,0.594-0.016,1.125-0.047,1.594h-85c-0.031-0.469-0.063-0.984-0.063-1.594c0-9.719-0.875-18.531-2.859-26.75 c-2.906-12.359-8.391-22.922-14.828-32.25c-6.484-9.406-13.813-18-22.266-28.656c-14.375-18.047-22.906-40.734-22.922-65.609 c0.016-29.172,11.766-55.391,30.891-74.547C200.609,53.797,226.813,42.031,256,42.031s55.406,11.766,74.547,30.875 c19.109,19.156,30.859,45.375,30.875,74.547C361.406,172.344,352.875,195.031,338.531,213.063z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M256,512c17.406,0,31.531-14.109,31.531-31.531h-63.063C224.469,497.891,238.594,512,256,512z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M310.047,369.375H201.969c-9.406,0-17.016,7.609-17.016,17c0,9.406,7.609,17.016,17.016,17.016h108.078 c9.391,0,17.016-7.609,17.016-17.016C327.063,376.984,319.438,369.375,310.047,369.375z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M310.047,424.297H201.969c-9.406,0-17.016,7.609-17.016,17.016c0,9.391,7.609,17,17.016,17h108.078 c9.391,0,17.016-7.609,17.016-17C327.063,431.906,319.438,424.297,310.047,424.297z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTips);
export default __webpack_public_path__ + "static/media/tips.b4b3aa4a6398775b181aca9339cf22b6.svg";
export { ForwardRef as ReactComponent };